<template>
  <!-- <div
    v-if="visitBookingEnabled || gantryAccessQrEnabled"
    id="emailmobile-login-page"
    v-resize="setContentHeight"
    :class="[
      { 'inset-box-shadow': !isMobileOrStandaloneMode },
      onsiteMode ? 'bg-blue-dark' : 'bg-blue-dark',
    ]"
  > -->
  <div
    v-if="visitBookingEnabled || gantryAccessQrEnabled"
    id="emailmobile-login-page"
    v-resize="setContentHeight"
    :class="[
      { 'inset-box-shadow': !isMobileOrStandaloneMode },
      onsiteMode ? 'bg-blue-dark' : 'bg-blue-dark',
    ]"
  >
    <!-- Toolbar -->
    <v-toolbar
      v-show="visitBookingEnabled && navFromLoginOptions"
      dark color="transparent" class="pr-1">
        <v-btn
          icon
          @click="$router.push('/login/options', () => {})"
          style="z-index: 1"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-toolbar-title>Login</v-toolbar-title>
    </v-toolbar>

    <div ref="emailMobileLoginScrollable" class="scrollable box-shadow-inset">
      <v-card
        color="transparent"
        style="height: inherit"
        class="white--text flex-center-container px-5"
        elevation="24"
      >
        <div>
          <div
            v-if="visitBookingEnabled && navFromLoginOptions"
            class="text-title text-center pb-8">
            An OTP (One-Time Password) will be sent to the mobile number
            or email address entered
          </div>
          <div
            v-else
            class="text-title text-center pb-8">
            <div>Welcome to {{ getCurrentBranchName }}.</div>
            <div>Please enter your Singapore registered mobile number, or email to receive a One-Time PIN (OTP) to generate a QR code day pass.</div>
          </div>
          <v-container>
            <v-form
              ref="form"
              v-model="isFormValidated"
              v-on:submit.prevent
            >
              <v-row class="no-gutters">
                <v-text-field
                  ref="toFocus"
                  elevation="21"
                  dark
                  background-color="primary"
                  class="border-radius: 20px mt-3"
                  clearable
                  single-line
                  solo
                  prepend-inner-icon="mdi-account"
                  :rules="emailMobileRules"
                  required
                  v-model.trim="otpChannelValue"
                >
                  <div slot="label">SG Mobile/Email</div>
                </v-text-field>
              </v-row>
              <v-row class="no-gutters flex-center-container">
                <div class="px-4x mt-1 mb-7" style="width: 100%">
                  <v-btn
                    @click="requestOtp"
                    onfocus="this.blur()"
                    color="orange darken-2"
                    large
                    block
                    dark
                    :disabled="!isFormValidated || otpTimer.isLoading"
                  >
                    Request OTP
                    <span>
                      <v-progress-circular
                        :rotate="-90"
                        :size="26"
                        :width="2"
                        color="white"
                        style="font-size: 11px; margin-left: 50px"
                        class="px-0"
                        v-show="otpTimer.isLoading"
                        >{{ otpTimer.timerInSeconds }}
                      </v-progress-circular></span
                    >
                  </v-btn>
                </div>
              </v-row>
              <v-row
                v-show="visitBookingEnabled && navFromLoginOptions"
                class="no-gutters flex-center-container">
                  <a href="#" class="white--text text-medium" @click="casAuth"
                    >Log in with myLibrary username</a
                  >
              </v-row>
            </v-form>
          </v-container>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import apiHelper from "@/helpers/apiHelper";
import businessLogic from "@/helpers/businessLogic";
import constants from "../helpers/constants";

export default {
  name: "EmailMobileLogin",
  data() {
    return {
      isFormValidated: false,
      triggerOtpTimer: false,
      otpChannelValue: String,
      emailMobileRules: [
        (value) => !!value || "Required",
        (value) =>
          /(^[8,9]\d{7}$)|(^\S+@\S+\.+\S+$)/.test(value) ||
          window.$msg.invalidEmailMobile,
      ],
    };
  },
  computed: {
    ...mapState(["otpTimer"]),
    ...mapGetters(["authenticated", "visitBookingEnabled", "gantryAccessQrEnabled", "getCurrentBranchName"]),
    navFromLoginOptions() {
      return this.$route.query.from === 'loginOptions'
    },
    getCurrentBranchName() {
      return businessLogic.getCurrentBranchName()
    },
    otpChannelId: {
      get() {
        return this.isValidEmail(this.otpChannelValue);
      },
      set(newValue) {
        return newValue;
      },
    },
  },
  methods: {
    casAuth() {
      this.auth(this.$route.name);
    },
    setContentHeight() {
      if (this.$refs.emailMobileLoginScrollable) {
        const heights = this.heights();
        const contentHeight = heights.screen - heights.toolbar - heights.noticeBarHeight;

        this.$refs.emailMobileLoginScrollable.style.height =
          contentHeight + "px";
      }
    },
    isValidEmail(otpCannelValue) {
      if (otpCannelValue) {
        if (otpCannelValue.match(RegExp(/^\S+@\S+\.+\S+$/))) {
          return constants.channelId.Email;
        } else if (otpCannelValue.match(RegExp(/^[8,9]\d{7}$/))) {
          return constants.channelId.SMS;
        }
      }
    },
    async requestOtp() {
      const validationResult = this.$refs.form.validate();

      if (validationResult) {
        // console.log("Request Otp with otpchannel: ", this.otpChannelId + " , " + this.otpChannel.value);
        this.triggerOtpTimer = true;

        if (this.visitBookingEnabled || this.gantryAccessQrEnabled) {
          businessLogic.isOtpTimerRunning(
            window.$settings.resendOtpTimeIntervalInSeconds,
            this.time.nowMoment.format(),
            this.triggerOtpTimer
          );
        }

        const response = await apiHelper.requestOtp(
          this.otpChannelId,
          this.otpChannelValue
        );

        this.commonResponseHandler(
          response,
          window.$msg.otpGenerateSuccess,
          window.$msg.otpGenerateFail,
          null,
          () =>
            this.$router.push({
              name: "ValidateOtp",
              params: {
                otpChannelId: this.otpChannelId,
                otpChannelValue: this.otpChannelValue,
                triggerOtpTimer: this.triggerOtpTimer,
              },
              query: { from: this.$route.query.from }
            }),
          null
        );
      }
    },
  },
  activated() {
    this.$nextTick(() => this.setContentHeight());
    this.$nextTick(() => this.$refs.toFocus.focus());

    this.otpChannelId = null;
    this.otpChannelValue = null;

    this.triggerOtpTimer = false;
    
    if (this.visitBookingEnabled || this.gantryAccessQrEnabled) {
      businessLogic.isOtpTimerRunning(
        window.$settings.resendOtpTimeIntervalInSeconds,
        this.time.nowMoment.format(),
        this.triggerOtpTimer
      );
    }

    // if (this.authenticated) {
    //   this.$router.replace({ name: "Home" });
    // }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.authenticated) {
        return next({ name: "Home" });
      } else {
        //To prevent from landing to casauth page if one of vistbooking or gantryaccessqr is disabled
        if (vm.visitBookingEnabled || vm.gantryAccessQrEnabled) {
          next();
        } else {
          apiHelper.casAuth();
        }
      }
    });
  },
};
</script>

<style>
#emailmobile-login-page .v-input__prepend-inner .v-icon {
  color: white !important;
}

#emailmobile-login-page .v-messages__message {
  color: orange !important;
  font-weight: bold;
}

#emailmobile-login-page .mdi-close::before {
  color: orange !important;
}
</style>
